export const initFadeIn = () => {
    if (document.body.classList.contains('neos-backend')) return;

    const elements = document.querySelectorAll('.fade-in');
    const windowHeight = window.innerHeight;

    window.addEventListener('scroll', function () {
        for (const element of elements) {
            const elementHeight = element.offsetHeight;
            const elementPosition = element.getBoundingClientRect().top;
            const distanceFromTop = windowHeight - elementPosition;

            let opacity;
            let translateX;

            if (distanceFromTop > 0 && distanceFromTop < elementHeight * 1.25) {
                opacity = (distanceFromTop / (elementHeight * 1.25)).toFixed(2);
                translateX = ((distanceFromTop / (elementHeight * 1.25)).toFixed(2) * 2.5 - 2.5).toFixed(2);
            } else if (distanceFromTop >= elementHeight * 1.25) {
                opacity = 1;
                translateX = 0;
            } else {
                opacity = 0;
                translateX = -2.5;
            }

            element.style.setProperty('opacity', opacity);
            element.style.setProperty('--tw-translate-x', `${translateX}rem`);
        }
    });
};
